import DashboardLayout from "../pages/Dashboard/Layout/DashboardLayout";

import CrewSinister from "../pages/Catalogs/Crews/";
import EditCrew from "../pages/Catalogs/Crews/Update";
import Divisions from "../pages/Catalogs/Divisions";

const crewPages = {
  path: "/",
  component: DashboardLayout,
  name: "crewPages",
  title: "Cuadrillas",
  icon: "people_outline",
  excludedRoles: ["IDEAL"],
  children: [
    {
      path: "/cuadrillas",
      name: "Cuadrillas",
      title: "Cuadrillas",
      component: CrewSinister,
      meta: {
        ifUserCan: {
          view: "Crew/crew",
        },
      },
    },
    {
      path: "/cuadrillas/:id",
      name: "Editar Cuadrilla",
      props: true,
      component: EditCrew,
      meta: {
        ifUserCan: {
          change: "Crew/crew",
        },
      },
    },
    // {
    //   path: "/divisiones",
    //   name: "Divisiones",
    //   title: "Divisiones",
    //   component: Divisions,
    //   roles: ["ADMIN"],
    // },
  ],
};

export default crewPages;



// WEBPACK FOOTER //
// ./src/router/crewRoutes.js